import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const DetalleCuentaKPIs = ({ dataActual }) => {
    if(!dataActual) return null;
    return (
        <Row className="mb-4 g-2">
            <Col sm={6} lg={3}>
                <Card className="h-100 shadow-sm border-0 bg-white">
                    <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-muted mb-0 fw-bold" style={{ fontSize: '0.75rem' }}>SALDO ACTUAL</span>
                            <div className="bg-primary bg-opacity-10 text-primary rounded px-2 py-1" style={{ fontSize: '0.85rem' }}>
                                <FontAwesomeIcon icon="wallet" />
                            </div>
                        </div>
                        <h5 className="fw-bold text-dark mb-1">
                            ${dataActual.saldoActual.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                            <span className="text-muted ms-1 fw-normal" style={{ fontSize: '0.75rem' }}>{dataActual.moneda}</span>
                        </h5>
                        <div className="text-muted d-flex align-items-center" style={{ fontSize: '0.75rem' }}>
                            <FontAwesomeIcon icon="clock" className="me-1" /> Al corte de hoy
                        </div>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={6} lg={3}>
                <Card className="h-100 shadow-sm border-0 bg-white">
                    <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-muted mb-0 fw-bold" style={{ fontSize: '0.75rem' }}>INGRESOS (MES)</span>
                            <div className="bg-success bg-opacity-10 text-success rounded px-2 py-1" style={{ fontSize: '0.85rem' }}>
                                <FontAwesomeIcon icon="arrow-trend-up" />
                            </div>
                        </div>
                        <h5 className="fw-bold text-dark mb-1">
                            ${dataActual.ingresosMes.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                        </h5>
                        <div className="text-success d-flex align-items-center fw-medium" style={{ fontSize: '0.75rem' }}>
                            <FontAwesomeIcon icon="arrow-up" className="me-1" /> 12% vs mes anterior
                        </div>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={6} lg={3}>
                <Card className="h-100 shadow-sm border-0 bg-white">
                    <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-muted mb-0 fw-bold" style={{ fontSize: '0.75rem' }}>EGRESOS (MES)</span>
                            <div className="bg-danger bg-opacity-10 text-danger rounded px-2 py-1" style={{ fontSize: '0.85rem' }}>
                                <FontAwesomeIcon icon="arrow-trend-down" />
                            </div>
                        </div>
                        <h5 className="fw-bold text-dark mb-1">
                            ${dataActual.egresosMes.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                        </h5>
                        <div className="text-danger d-flex align-items-center fw-medium" style={{ fontSize: '0.75rem' }}>
                            <FontAwesomeIcon icon="arrow-down" className="me-1" /> 5% vs mes anterior
                        </div>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={6} lg={3}>
                <Card className="h-100 shadow-sm border-0 bg-white border-start border-warning border-3">
                    <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-muted mb-0 fw-bold" style={{ fontSize: '0.75rem' }}>POR CONCILIAR</span>
                            <div className="bg-warning bg-opacity-10 text-warning rounded px-2 py-1" style={{ fontSize: '0.85rem' }}>
                                <FontAwesomeIcon icon="exclamation-circle" />
                            </div>
                        </div>
                        <h5 className="fw-bold text-dark mb-1">
                            {dataActual.pendientes} <span className="text-muted ms-1 fw-normal" style={{ fontSize: '0.75rem' }}>movs</span>
                        </h5>
                        <div className="text-warning d-flex align-items-center fw-medium text-dark" style={{ fontSize: '0.75rem' }}>
                            Requiere tu atención
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

DetalleCuentaKPIs.propTypes = {
    dataActual: PropTypes.shape({
        saldoActual: PropTypes.number,
        moneda: PropTypes.string,
        ingresosMes: PropTypes.number,
        egresosMes: PropTypes.number,
        pendientes: PropTypes.number
    })
};
